import { ModalWrapper } from '@gluedigital/modal';
import { Route, Routes } from 'react-router';
import Bootstrap from 'src/components/Bootstrap/Bootstrap';
import Chat from 'src/components/Chat/Chat';
import ErrorBoundary from 'src/components/ErrorBoundary/ErrorBoundary';
import Meta from 'src/components/Meta/Meta';
import ErrorShareChat from 'src/components/ShareChat/ErrorShareChat';
import ShareChat from 'src/components/ShareChat/ShareChat';
import Home from './Home/Home';
import NotFound from './NotFound/NotFound';

const App = () => {
	return (
		<Bootstrap>
			<ModalWrapper>
				<>
					<Meta />
					<main id="app">
						<ErrorBoundary>
							<Routes>
								<Route path="/" element={<Home />}>
									<Route index element={<Chat />} />
									<Route
										path="/share/:id"
										element={
											<ErrorBoundary fallback={<ErrorShareChat />}>
												<ShareChat />
											</ErrorBoundary>
										}
									/>
								</Route>
								<Route path="*" element={<NotFound />} />
							</Routes>
						</ErrorBoundary>
					</main>
				</>
			</ModalWrapper>
		</Bootstrap>
	);
};

export default App;
